module.exports = __webpack_public_path__ + "img/lesson.3b4c399d.svg";